// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily) => ({
	htmlFontSize: 16,
	fontFamily,
	fontWeightLight: 300,
	fontWeightRegular: 400,
	fontWeightMedium: 500,
	fontWeightBold: 700,
	fontSize: 14.64,
	h1: {
		fontSize: '2rem',
		lineHeight: '2.5rem',
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	h2: {
		fontSize: '1.75rem',
		lineHeight: '2.25rem',
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	h3: {
		fontSize: '1.5rem',
		lineHeight: '2rem',
		fontWeight: 300,
		letterSpacing: 0.2,
	},
	h4: {
		fontSize: '1.375rem',
		lineHeight: '1.75rem',
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	h5: {
		fontSize: '1.25rem',
		lineHeight: '1.625rem',
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	h6: {
		fontSize: '2rem',
		lineHeight: '2.5rem',
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	// Regular
	body: {
		fontSize: '1rem',
		lineHeight: 1.5,
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	// small text
	body1: {
		fontSize: '0.875rem',
		lineHeight: 1.375,
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	// smaller text
	body2: {
		fontSize: '0.75rem',
		lineHeight: 1.25,
		fontWeight: 400,
		letterSpacing: 0.2,
	},
	button: {
		textTransform: 'none',
		lineHeight: 'normal'
	}
});

export default Typography;
